/* eslint-disable jsx-a11y/anchor-is-valid */
import './Footer.scss';
import { Footer } from '@lmig/lmds-react-footer';
import { Disclaimer } from '@lmig/lmds-react-typography';
import { useEffect, useState } from 'react';
import { GetFooterContent } from './PageFooterAPI';
import { LogoLibertyMutualMedallion, LogoSafeco, LogoLibertyMutualVert } from '@lmig/lmds-react-logos';
import RichText from 'Feature/PageContent/Shared/Tiles/RichText';
import PLFooterLinks from './PLFooterLinks';
import PLFooterSocial from './PLFooterSocial';
import BLFooterLinks from './BLFooterLinks';
import BLFooterSocial from './BLFooterSocial';
import OBFooterLinks from './OBFooterLinks';
import OBFooterSocial from './OBFooterSocial';
import { IconCPRA } from '@lmig/lmds-react-icons';
import { isOneBrand, isPL, isPublic } from 'Foundation/Configurations/GlobalConfiguration';
import { StringHelper } from 'Utilities/StringHelper';
import UnauthenticatedPageFooter from './UnauthenticatedPageFooter';

interface footerContent {
  Content: string;
  OneBrandLinks: string;
  OneBrandContent: string;
}

export default function PageFooter() {
  const [footerContent, setFooterContent] = useState<footerContent | undefined>(undefined);

  useEffect(() => {
    const getFooterContentAsync = async () => {
      const footerContent: any = await GetFooterContent();
      if (footerContent && (StringHelper.hasNonEmptyString(footerContent.Content) || StringHelper.hasNonEmptyString(footerContent.OneBrandLinks) ||         StringHelper.hasNonEmptyString(footerContent.OneBrandContent))) {
        setFooterContent(footerContent); //sort panels by sortorder
      }
    };
    getFooterContentAsync();
  }, []);

  const window: IWindow = global.window;
  function CRPAClick() {
    if (window?.utag?.gdpr) {
      window.utag.gdpr.showDoNotSellPrompt();
    }
  }

  return (
    <>
      {isPublic() ? <UnauthenticatedPageFooter /> :
      isOneBrand() ? <Footer fullWidth={true} className="standard-footer">
        <div className={"portal-footer-top-section-one-brand"}>
            <div className="portal-footer-flexbox portal-footer portal-footer-bottom-border">
              <div className="footer-content">
                <div className="portal-footer-icon">
                  <LogoLibertyMutualVert key="lm-desktop-logo-footer" className="lm-desktop-logo-footer" color="blue"/>   
                  <LogoLibertyMutualMedallion key="lm-tablet-logo-footer" className="lm-tablet-logo-footer" color="blue" />
                </div>
                <div className="portal-content-links lm-blue-footer">
                  {footerContent && footerContent.OneBrandContent && (
                    <RichText className="footer-publisher-section" content={footerContent.OneBrandContent} />
                  )}
                </div>
              </div>
              <div className="portal-footer-social-icon-row">
                <OBFooterSocial/>
              </div>
            </div>
            <div className="portal-footer-flexbox portal-footer portal-footer-flexbox-link-rows">
              {footerContent && footerContent.OneBrandLinks && 
              <OBFooterLinks links={footerContent.OneBrandLinks} />}
              <div className="portal-content-links lm-blue-footer">
                <span className="icon-link">
                  <IconCPRA color="blue" size="24" />
                  <a
                    rel="noopener noreferrer"
                    href="https://privacyportal.onetrust.com/hosted-webform/consent/50577d86-8d39-4310-9583-33e6d3da8e17/9b108b70-4ef6-4d93-b7ec-60e41f03b292"
                    target="_blank"
                    title="View your California Privacy Choices"
                  >
                    Your California Privacy Choices
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    rel="noopener noreferrer"
                    onClick={() => CRPAClick()}
                    target="_blank"
                    title="Do Not Sell or Share My Personal Information (CA Residents Only)"
                  >
                    Do Not Sell or Share My Personal Information (CA Residents Only)
                  </a>
                </span>
              </div>
            </div>
        </div>
        <div className={"container portal-footer-bottom-section-one-brand"}>
          <Disclaimer>
            <p>© {new Date().getFullYear()} Liberty Mutual Insurance Company, 175 Berkeley Street, Boston, MA 02116</p>
          </Disclaimer>
        </div>
      </Footer> : 
      <Footer fullWidth={true} className="standard-footer">
        <div className="portal-footer-top-section">
          <>
            <div className="portal-footer-flexbox portal-footer">
              <div className="portal-footer-icon">
                {isPL() ? (
                  <LogoSafeco color="inverse" className="portal-footer-icon-width" />
                ) : (
                  <LogoLibertyMutualMedallion color="inverse" />
                )}
              </div>
              <div className="pl-footer-content">
                <div className="portal-content-links lm-blue-footer">
                  {footerContent && StringHelper.hasNonEmptyString(footerContent.Content) ? (
                    <>
                      <RichText className="footer-publisher-section" content={footerContent.Content} />
                    </>
                  ) : null}
                </div>
              </div>
              <div className="portal-footer-social-icon-row">{isPL() ? <PLFooterSocial /> : <BLFooterSocial />}</div>
            </div>
            <div className="portal-footer-flexbox portal-footer portal-footer-flexbox-link-rows">
              <div className="portal-content-links lm-blue-footer">
                {isPL() ? <PLFooterLinks /> : <BLFooterLinks />}
              </div>
              <div className="portal-content-links lm-blue-footer">
                <span className="icon-link">
                  <IconCPRA color="inverse" size="24" />
                  <a
                    rel="noopener noreferrer"
                    href="https://privacyportal.onetrust.com/hosted-webform/consent/50577d86-8d39-4310-9583-33e6d3da8e17/9b108b70-4ef6-4d93-b7ec-60e41f03b292"
                    target="_blank"
                    title="View your California Privacy Choices"
                  >
                    Your California Privacy Choices
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    rel="noopener noreferrer"
                    onClick={() => CRPAClick()}
                    target="_blank"
                    title="Do Not Sell or Share My Personal Information (CA Residents Only)"
                  >
                    Do Not Sell or Share My Personal Information (CA Residents Only)
                  </a>
                </span>
              </div>
            </div>
          </>
        </div>
        <div className="container portal-footer-bottom-section">
          <Disclaimer>
            <p>© {new Date().getFullYear()} Liberty Mutual Insurance Company, 175 Berkeley Street, Boston, MA 02116</p>
          </Disclaimer>
        </div>
      </Footer>}
    </>
  );
}
